var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StoredWorkflowDetailsProvider',{attrs:{"stored-workflow-id":_vm.storedWorkflowId},scopedSlots:_vm._u([{key:"default",fn:function({ result: item, loading }){return [(!loading && _vm.currentUser.id)?_c('InvocationsList',{attrs:{"user-id":_vm.currentUser.id,"stored-workflow-id":item.id,"stored-workflow-name":item.name}}):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }